import styled, { css } from 'styled-components'

export const TitleContainer = styled.span`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};

  ${props =>
    props.isParent &&
    css`
      cursor: pointer;
      color: ${props => props.theme.colors.text.muted};

      svg,
      svg path {
        color: ${props => props.theme.colors.text.muted};
        fill: ${props => props.theme.colors.text.muted};
      }

      &:hover {
        color: ${props => props.theme.colors.outline.default};

        svg,
        svg path {
          color: ${props => props.theme.colors.outline.default};
          fill: ${props => props.theme.colors.outline.default};
        }
      }
    `}
`
